"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleEvents = handleEvents;

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var firebase = _interopRequireWildcard(require("firebase/app"));

var _runtime = _interopRequireDefault(require("../utils/runtime"));

var _index = require("../filters/index");

var _index2 = _interopRequireDefault(require("../logger/index"));

var _trace = require("../utils/trace");

var _path = require("../utils/path");

var _utils = require("../utils");

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * 
 * @param {Event} event
 */
function formatEvent(event) {
  var _event$message = event.message,
      metrics = _event$message.metrics,
      attributes = _event$message.attributes;

  var duration = metrics.duration,
      restMetrics = _objectWithoutProperties(metrics, ["duration"]);

  var filteredAttributes = (0, _index.filterAttributes)(_constants.FIREBASE_ENDPOINT_NAME, event.type, attributes);
  var formatted = {
    traceName: event.traceName,
    startTime: event.startTime || performance.timing.navigationStart,
    duration: metrics.duration,
    options: {
      metrics: _objectSpread({}, restMetrics),
      attributes: _objectSpread({}, filteredAttributes)
    }
  };
  return formatted;
}
/**
 * 
 * @param {TransPortOptions} options
 * @param {function} metricsPredicate 
 */


function readyTransport(options, metricsPredicate) {
  if (!(0, _utils.currentRouteChannelEnabled)(_constants.FIREBASE_ENDPOINT_NAME)) {
    return false;
  }

  var traceName = options.traceName;

  if (!(0, _trace.checkTraceName)(traceName)) {
    _index2.default.error('trace name 不合法', traceName);

    return false;
  }

  if (options.options && !(0, _index.isAttributesValid)(options.options.attributes)) {
    _index2.default.error('不合法的 attributes', options.options.attributes, traceName);

    return false;
  }

  if (options.options && !(0, _index.isMetricsValid)(options.options.metrics, metricsPredicate)) {
    _index2.default.error('不合法的 metrics', options.options.metrics, traceName);

    return false;
  }

  var shouldLog = _runtime.default.get('shouldLog');

  var shouldReport = _runtime.default.get('shouldReport');

  if (shouldLog) {
    _index2.default.info("\n[performance-collect]:\n  trace: ".concat(traceName, ",\n  duration: ").concat(options.duration || 0, ",\n  options: ").concat(JSON.stringify(options.options, null, 4), "\n"));
  }

  if (shouldReport) {
    transport(_objectSpread({}, options, {
      traceName: traceName
    }));
  }

  return true;
}
/**
 * 
 * @param {TransPortOptions} options 
 */


function transport(_ref) {
  var traceName = _ref.traceName,
      startTime = _ref.startTime,
      duration = _ref.duration,
      options = _ref.options;
  var pref = firebase.performance();
  var trace = pref.trace(traceName);
  trace.record(startTime || Date.now(), duration, options);
}
/**
 * 
 * @param {Array<Event>} events 
 */


function handleEvents(events) {
  if (!firebase.apps.length) {
    _index2.default.error('firebase 未初始化');

    return false;
  }

  if (!(0, _utils.currentRouteChannelEnabled)(_constants.FIREBASE_ENDPOINT_NAME)) {
    return false;
  }

  events.forEach(function (event) {
    var e = formatEvent(event);
    readyTransport(e, event.message.metricsPredicate);
  });
}